import React from "react"

const subheadingsData = {
    1:[
        { 
            title: "About Me",
            content: `
            Hello! I’m Krystle Mitchell, a writer turned web developer.
            As a Full-Stack Developer, I blend creativity and technical expertise to build engaging and functional web applications.
            My journey from writing to coding has equipped me with a unique perspective on storytelling through technology,
            allowing me to create user-centric designs that not only meet business objectives but also resonate with users.
            I specialize in  JavaScript, React, Node.js, etc, and I thrive in collaborative environments where I can contribute to 
            all aspects of development, from initial concept to deployment. When I’m not coding, you can find me reading, swimming, skiiing, 
            or hiking. I’am passionate about continuous learning and staying up-to-date with industry trends, which drives my commitment to 
            delivering innovative solutions. Let’s connect and explore how we can work together to bring your ideas to life!
            
            `
                
                        
        ,
        },
    ],
    2:[
        {
            title: "FullStack Developer",
            content: (
                <>
                    <p>
                         BloomTech - Full Stack Developer
                    </p>
             
                </>
            ),
        },
        {
            title: "Journalisn",
            content: (
                <>
                    <p>
                         AA Journalism
                    </p>
             
                </>
            ),
        },
    ],
    3:[
        {
            title: "Web Developer",
            content: (
                <>
                    <ul>
                        <li>Developed and managed a user-friendly website to improve employee access and streamline daily reporting processes.</li>
                        <li>Implemented responsive design to ensure optimal performance across devices, enhancing user experience.</li>
                        <li></li>
                    </ul>
             
                </>
            ),
        },
        {
            title: "Office Manager",
            content: (
                <>
                    <ul>
                        <li> Led document management, ensuring accuracy and compliance with internal procedures and safety standards.</li>
                        <li> Developed and maintained document templates, streamlining onboarding processes and appointment scheduling.</li>
                        <li>Managed the digital filing structure using Google Workspace, ensuring proper classification and organization of documents.</li>
                        <li>Utilized analytics tools to monitor site performance and user engagement, leading to continuous improvements.</li> 
                        <li>Conducted regular maintenance and updates to ensure security and functionality of the website</li>
                        <li>Trained staff on website usage and features, facilitating smoother operations and increased adoption.</li>      
                    </ul>
             
                </>
            ),
        },
        
    ],
}

export default subheadingsData;
